import $ from 'zepto';
import { onDocumentReady, expose } from '../../main';
import LoaderSpinner from './LoaderSpinner';
import { getLoaderSpinnerClasses } from '../../utils/constants/classes';

export const loaderSpinners = {};

export const hideLoaderSpinner = (id) => {
  if (!id) {
    return null;
  }

  const loaderSpinnersInstance = loaderSpinners[id];
  return loaderSpinnersInstance ? loaderSpinnersInstance.hideLoaderSpinner() : [];
};

export const showLoaderSpinner = (id) => {
  if (!id) {
    return null;
  }

  const loaderSpinnersInstance = loaderSpinners[id];
  return loaderSpinnersInstance ? loaderSpinnersInstance.showLoaderSpinner() : [];
};

export const initLoaderSpinner = ($context, prefix) => {
  const { loaderSpinnerLayerSelector } = getLoaderSpinnerClasses(prefix);
  // Get all spinner layer elements in the DOM
  const $loaderSpinnerLayers = $context.find(loaderSpinnerLayerSelector);
  if ($loaderSpinnerLayers.length > 0) {
    $loaderSpinnerLayers.each((index, loaderElement) => {
      const $loaderSpinnerLayer = $(loaderElement);
      const loaderSpinnerId = $loaderSpinnerLayer.attr('id');
      loaderSpinners[loaderSpinnerId] = new LoaderSpinner(prefix).initLoaderSpinnerLayer($loaderSpinnerLayer);
    });
    expose({ loaderSpinner: { showLoaderSpinner, hideLoaderSpinner } });
  }
};

onDocumentReady('LoaderSpinner', () => {
  const $body = $(document.body);
  initLoaderSpinner($body, 'xvx-');
  initLoaderSpinner($body, 'xppvx_');
});

export default {
  initLoaderSpinner,
};
